// Login
const errorLoginText = 'Authorization failed. Please check your credentials and try again.';

// Forgot Password
const errorForgotPasswordText = 'We could not find an account with that email address. Please try again.';

// View Document
const errorViewDocumentText = 'Failed to load the document. Please try again.';
const errorDownloadDocumentText = 'Failed to download the document. Please try again.';

// Document
const errorAddDocumentText = 'File size should be less than 5MB!';

// Comment
const errorViewCommentText = 'Failed to load the comment. Please try again.';

// Receipt
const errorViewReceiptText = 'Failed to load the receipt. Please try again.';

// Request Check
const successRequestCheckText = 'Your request has been sent successfully';
const errorRequestCheckText = 'Failed to send request. Please try again.';

export {
  errorLoginText,
  errorForgotPasswordText,
  errorAddDocumentText,
  errorViewDocumentText,
  errorViewCommentText,
  errorViewReceiptText,
  successRequestCheckText,
  errorRequestCheckText,
  errorDownloadDocumentText
};
